<template>
    <div class="container">
        <h1
            class="container__standard-header container__standard-header--modify"
        >
            {{ $t(`${TRANSLATION_KEY}.redirectToTheClientZoneHeader`) }}
        </h1>
        <div class="row--log-into-client-zone">
            <img
                style="visibility"
                src="../../assets/loading-icon.gif"
                alt="loading-to-the-client-zone"
                cy-data="blackout"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { SET_PROGRESS } from '@/constants/mutation-types';
import { PROGRESS_BAR_TIMES } from '@/constants/progress-bar-times';

const TRANSLATION_KEY = 'steps.ClientZoneLogin';

export default defineComponent({
    name: 'AccountOpen',
    setup() {
        const store = useStore();

        const isPaymentAllowed = computed(
            () => store.state.formData.isPaymentAllowed
        );

        onMounted(() => {
            store.commit(SET_PROGRESS, PROGRESS_BAR_TIMES.ACCOUNT_OPEN);
        });

        return {
            TRANSLATION_KEY,
            isPaymentAllowed,
        };
    },
});
</script>
